import { isNullOrUndefinedOrEmpty } from "base/utils";

export const fractionMap = {
  0.25: "¼",
  0.33: "⅓",
  0.5: "½",
  0.67: "⅔",
  0.75: "¾",
  1.25: "1¼",
  1.33: "1⅓",
  1.5: "1½",
  2.5: "2½",
  2.75: "2¾",
  "1/8": "⅛",
  "1/4": "¼",
  "1/3": "⅓",
  "1/2": "½",
  "2/3": "⅔",
  "3/4": "¾",
  "1 1/4": "1¼",
  "1 1/3": "1⅓",
  "1 1/2": "1½",
  "2 1/2": "2½",
  "2 3/4": "2¾",
};

export const formatQuantity = (quantity) => {
  if (isNullOrUndefinedOrEmpty(quantity)) {
  return "";
  }

  const numericQuantity = Number(quantity);

  if (isNaN(numericQuantity)) {
    return fractionMap[quantity] || quantity;
  }

  const wholeNumber = Math.floor(numericQuantity);
  const decimal = numericQuantity - wholeNumber;

  const fractionLookup = [
    { value: 1 / 8, display: "⅛" },
    { value: 1 / 6, display: "⅙" },
    { value: 1 / 4, display: "¼" },
    { value: 1 / 3, display: "⅓" },
    { value: 3 / 8, display: "⅜" },
    { value: 1 / 2, display: "½" },
    { value: 5 / 8, display: "⅝" },
    { value: 2 / 3, display: "⅔" },
    { value: 3 / 4, display: "¾" },
    { value: 5 / 6, display: "⅚" },
    { value: 7 / 8, display: "⅞" },
  ];

  let closestFraction = null;
  let smallestDifference = Infinity;

  fractionLookup.forEach((fraction) => {
    const difference = Math.abs(decimal - fraction.value);

    if (difference < smallestDifference) {
      smallestDifference = difference;
      closestFraction = fraction;
    }
  });

  // Use a familiar cooking fraction when the value is reasonably close
  if (closestFraction && smallestDifference <= 0.05) {
    if (wholeNumber === 0) {
      return closestFraction.display;
    }

    return `${wholeNumber}${closestFraction.display}`;
  }

  // Whole numbers should display without decimals
  if (Math.abs(decimal) < 0.01) {
    return wholeNumber.toString();
  }

  // Otherwise keep a clean decimal
  return numericQuantity.toFixed(2).replace(/\.?0+$/, "");
};
